import { MapMarkerRadiusOutlineIcon } from './MapMarkerRadiusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 865AB612-D546-431D-85A8-52C305B263F8
 * name map-marker-radius-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-radius-outline.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 * - Home Automation 
 */
export const LocationRadiusOutlineIcon = MapMarkerRadiusOutlineIcon;
export default LocationRadiusOutlineIcon